var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "content-class": "renew-modal", "max-width": "500" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c(
            "div",
            {
              staticClass:
                "content-top d-custom-flex justify-space-between primary"
            },
            [
              _c("span", { staticClass: "white--text fw-bold" }, [
                _vm._v(_vm._s(_vm.$t("session.RenewToken_dialogTitle")))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "v-card",
            [
              _c("v-card-text", [
                _c("p", { staticClass: "renew-token__header-xlarge" }, [
                  _vm._v(_vm._s(_vm.$t("session.RenewToken_header1")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "renew-token__header-large" }, [
                  _vm._v(_vm._s(_vm.$t("session.RenewToken_header2")))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "renew-token__body" }, [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("session.RenewToken_content")) +
                      "\n\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "renew-token__refresh-btn" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { block: "", depressed: "", large: "" },
                        on: { click: _vm.refresh }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("session.RenewToken_btnText")) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e34d39c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e34d39c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RenewToken.vue
// module id = M58I
// module chunks = 5